export class OrderRow {
    id: number;
  }
  